import React, { PureComponent } from 'react';
import Carousel from 'react-elastic-carousel';
import CarouselItem from './CarouselItem';

class PostCarousel extends PureComponent {
  constructor(props) {
    try {
      super(props);
      this.state = {
        fileList: [],
        showDeleteOption: false,
        deletedItems: [],
      };
    } catch (error) {
      console.log(error);
    }
  }

  componentDidUpdate() {
    try {
      if (this.props.items && this.props.items.length > 0) {
        this.setState({
          fileList: this.props.items,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  deleteOption() {
    return this.state.showDeleteOption ? (
      <button>
        <img src="/img/close.svg" />
      </button>
    ) : (
      ''
    );
  }
  setdeleteOption(val) {
    try {
      this.setState({
        showDeleteOption: val,
      });
    } catch (err) {
      console.log(err);
    }
  }
  componentDidMount() {
    try {
      if (this.props.items && this.props.items.length > 0) {
        this.setState({
          fileList: this.props.items,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  async deleteItem(item) {
    try {
      let fileList = [...this.state.fileList];
      let deletedItems = [...this.state.deletedItems];

      let ele = fileList.find((obj) => obj.id === item);
      let index = fileList.indexOf(ele);
      fileList.splice(index, 1);
      deletedItems.push(item);

      await this.setState(
        {
          fileList: fileList,
          deletedItems: deletedItems,
        },
        () => {
          this.props.onDeleteItem(item);
        },
      );
    } catch (error) {
      console.log(error);
    }
  }
  render() {
    return (
      <>
        {this.state.fileList.length > 0 ? (
          <Carousel
            itemPadding={[0, 5]}
            itemsToShow={4}
            className="postCarousel"
            pagination={false}
            tiltEasing="ease"
          >
            {this.state.fileList && this.state.fileList.length > 0
              ? this.state.fileList.map((item) => {
                  return (
                    <CarouselItem
                      onDeleteItem={(item) => this.deleteItem(item)}
                      item={item}
                      key={item.id}
                    />
                  );
                })
              : ''}
          </Carousel>
        ) : (
          ''
        )}
      </>
    );
  }
}

export default React.memo(PostCarousel);
